import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

const FILTER_DIMS = ['size', 'category', 'use_case', 'price_tier', 'gender'];

function serialize(p) {
  const sp = new URLSearchParams();
  Object.entries(p).forEach(([k, v]) => {
    if (Array.isArray(v)) v.forEach((x) => sp.append(k, x));
    else if (v != null) sp.append(k, v);
  });
  return sp.toString();
}

export async function getInventoryHealth(dims, filters = {}) {
  const params = { dims: (dims || []).join(',') };
  FILTER_DIMS.forEach((d) => {
    if (filters[d] && filters[d].length) params[d] = filters[d];
  });
  const res = await axios.get(`${API_BASE}/inventory-health`, {
    headers: authHeader(), params, paramsSerializer: serialize,
  });
  return res.data;
}

export async function getInventoryHealthItems(metric, filters = {}, offset = 0, limit = 30) {
  const params = { metric, offset, limit };
  FILTER_DIMS.forEach((d) => {
    if (filters[d] && filters[d].length) params[d] = filters[d];
  });
  const res = await axios.get(`${API_BASE}/inventory-health/items`, {
    headers: authHeader(), params, paramsSerializer: serialize,
  });
  return res.data;
}
